export default function DotSpinner({
  size = 18,
  className = "text-white",
  speedSec = 0.8,
}) {
  // center is (9, 9) because original viewBox is 0 0 18 18
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="loading"
    >
      <g>
        {/* bright dot */}
        <circle cx="9" cy="3" r="1.5" fill="currentColor" />
        {/* faded dots */}
        <circle cx="9" cy="15" r="1.5" fill="currentColor" opacity="0.3" />
        <circle cx="3" cy="9" r="1.5" fill="currentColor" opacity="0.3" />
        <circle cx="15" cy="9" r="1.5" fill="currentColor" opacity="0.3" />
        <circle
          cx="13.2426"
          cy="4.7574"
          r="1.5"
          fill="currentColor"
          opacity="0.3"
        />
        <circle
          cx="4.7574"
          cy="13.2426"
          r="1.5"
          fill="currentColor"
          opacity="0.3"
        />
        <circle
          cx="13.2426"
          cy="13.2426"
          r="1.5"
          fill="currentColor"
          opacity="0.3"
        />
        <circle
          cx="4.7574"
          cy="4.7574"
          r="1.5"
          fill="currentColor"
          opacity="0.3"
        />

        {/* rotation animation */}
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 9 9"
          to="360 9 9"
          dur={`${speedSec}s`}
          repeatCount="indefinite"
        />
      </g>
    </svg>
  );
}
